class ParentPermissions {
    constructor({ show = false, sellerName = false } = {}) {
        this.show = show
        this.sellerName = sellerName
    }
}

export default ParentPermissions
